module.exports = __webpack_public_path__ + "img/baidu.1264197a.png";